import { render, staticRenderFns } from "./RoleDataruleModal.vue?vue&type=template&id=5300aabb&scoped=true"
import script from "./RoleDataruleModal.vue?vue&type=script&lang=js"
export * from "./RoleDataruleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5300aabb",
  null
  
)

export default component.exports